import React from 'react';
import cx from 'classnames';
import styles from './Radio.module.css';

interface Props {
  id: string;
  name?: string;
  label?: string;
  defaultChecked?: boolean;
  tabIndex?: number;
  classRadio?: string;
  classSpan?: boolean;
  value?: any;
  onChange: (ev: any) => void;
}

export const Radio = ({
  id,
  name,
  value,
  label,
  defaultChecked,
  tabIndex,
  classRadio,
  classSpan,
  onChange,
  ...props
}: Props) => {
  const change = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.persist();
    return change && onChange(e);
  };
  const spanClassRadio = cx('db absolute br-100 ba', styles.radioCheck, {
    [styles.spanClass]: classSpan,
  });
  const labelClass = cx('db relative pointer', styles.radioContainer);
  const textClass = cx(
    'db absolute left-1 ml8 ',
    {
      'top-0 f14 ttu': !classRadio,
    },
    classRadio,
  );
  return (
    <label htmlFor={id} className={labelClass}>
      {label && <span className={textClass}>{label}</span>}
      <input
        type="radio"
        className="dn radio"
        name={name}
        id={id}
        defaultChecked={defaultChecked}
        onChange={change}
        value={value}
        {...props}
      />
      <span tabIndex={tabIndex} className={spanClassRadio} />
    </label>
  );
};
